import { apiRequestActionType, apiSuccessActionType, apiErrorActionType, apiResetActionType } from 'utils/API/action-types'

export const DASHBOARD = 'DASHBOARD'
export const REQUEST_DASHBOARD = apiRequestActionType(DASHBOARD)
export const SUCCESS_DASHBOARD = apiSuccessActionType(DASHBOARD)
export const ERROR_DASHBOARD = apiErrorActionType(DASHBOARD)
export const RESET_DASHBOARD = apiResetActionType(DASHBOARD)